import styled from "styled-components";

export const TabContainer = styled.div`
  display: flex;
  border-bottom: 1px solid var(--hv-button-tertiary-outline-default);
`;

export const Tab = styled.label<{ active: boolean }>`
  background: ${({ active }) =>
    active ? "var(--hv-surface-widget)" : "transparent"};
  border: none;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  cursor: pointer;
  border: 1px solid
    ${({ active }) =>
      active ? "var(--hv-button-tertiary-outline-default)" : "transparent"};
  border-bottom: none;
  margin-bottom: -1px;
  z-index: 1;
  color: ${({ active }) =>
    active
      ? "var(--hv-text-normal-primary)"
      : "var(--hv-text-normal-secondary)"};
  font-weight: 500;
  font-size: 12px;
  line-height: 8px;
  padding: ${({ active }) => (active ? "5px 12px" : "6px 12px")};
  text-align: center;
  transition: all 0.1s ease-in-out;
  min-width: 80px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Input = styled.input`
  -webkit-appearance: none;
`;
